import React from 'react';
import { Switch as MuiSwitch } from '@mui/material';

const Switch = (props) => {
  return (
    <MuiSwitch {...props} />
  );
};

export default Switch;
